const COLORS = {
  brandLight: '#B199FF',
  brandDark: '#2D3047',
  // brandDark: '#274472',
  brandBase: '#F0F7F4',
};

export default COLORS;
